'use client'

import { Button } from '@src/components/Button/Button'
import { type CartPageContentProps } from '@src/components/CartPageContent/CartPageContent.props'
import { Container } from '@src/components/Container/Container'
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { useLocale } from '@src/i18n/LocaleProvider'
import { useTrackSelectCta } from '@src/utils/analytics.util'

export const EmptyCartPageContent = (props: CartPageContentProps) => {
  const trackSelectCta = useTrackSelectCta()
  const { locale, t: tcp } = useLocale('cart-page')

  const href = props.emptyCartCtaLink ?? locale.emptyCartRedirectUrl
  const onClick = () => {
    trackSelectCta({
      'cta url': href,
    })
  }

  return (
    <div className="h-[350px] bg-bodi-gray-pearl lg:h-[640px]">
      <Container className="flex h-full items-center justify-center text-center">
        <h1 className="text-heading-display-1 mb-8">
          {props.copy?.emptyCart ?? tcp('cart-empty')}
        </h1>
        <LocalizedLink onClick={onClick} href={href}>
          <Button>{props.copy?.continueShopping ?? tcp('cart-empty-cta')}</Button>
        </LocalizedLink>
      </Container>
    </div>
  )
}
